<template>
  <TwPopup
    :title="'设置' + ((activeCarItem && activeCarItem.remark) || '自定义') + '的地点'"
    :open="showPopup"
    :showFooter="false"
    :class="isPositionTop ? 'position-top' : ''"
    @change="handleChange"
  >
    <view class="container">
      <PlaceSelectPage
        pageFrom="popup"
        :selectType="selectType"
        :activeCarItem="activeCarItem"
        :defaultCityData="defaultCityData"
        @afterSetCommolyUsed="$emit('afterSetCommolyUsed')"
        @focus="(show) => (isPositionTop = show)"
      />
    </view>
  </TwPopup>
</template>

<script>
import TwPopup from '@/componentsV3/common/tw-popup/index.vue';
import PlaceSelectPage from '@/pages/index3.0/carIndex/selectPlace.vue';

export default {
  components: {
    TwPopup,
    PlaceSelectPage,
  },
  props: {
    activeCarItem: Object,
    selectType: {
      // 选择按钮作为设置常用功能还是编辑
      type: String,
      default: 'edit',
    },
    defaultCityData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showPopup: false,
      isPositionTop: false,
    };
  },
  mounted() {
    uni.$on('selectCommonlyPlace', (res) => {
      this.$emit('selectCommonlyPlace', res);
      this.handleChange(false);
    });
  },
  beforeDestroy() {
    uni.$off('selectCommonlyPlace');
  },
  methods: {
    handleChange(show) {
      this.showPopup = show;
    },
    open() {
      this.showPopup = true;
    },
    close() {
      this.isPositionTop = false;
      this.showPopup = false;
    },
  },
};
</script>

<style lang="less" scoped scoped>
.container {
  height: 100%;
  display: flex;
  flex-direction: column;
}
/deep/ .popup-content {
  padding: 0;
}
.position-top /deep/ .container.popup-container {
  height: calc(90vh - 88rpx);
}
</style>
<style lang="less" scoped>
.position-top > .uni-popup__wrapper.bottom {
  top: 10vh;
}
</style>
